import React, { FC } from "react";
import { readableTextOn, toCssColor } from "../utils/statusColor";

type StatusBadgeProps = {
  label: React.ReactNode;
  foregroundColor?: string | null;
  backgroundColor?: string | null;
  className?: string;
  title?: string;
};

/**
 * An event status shown with its FT1 colours. The text label is always rendered, so colour is
 * never the only signal. Without a usable colour it renders the label as plain text.
 */
const StatusBadge: FC<StatusBadgeProps> = ({
  label,
  foregroundColor,
  backgroundColor,
  className = "",
  title,
}) => {
  const bg = toCssColor(backgroundColor);
  const fg = toCssColor(foregroundColor) ?? (bg ? readableTextOn(bg) : undefined);

  if (!fg && !bg) {
    return (
      <span className={className} title={title}>
        {label}
      </span>
    );
  }

  return (
    <span
      data-testid="status-badge"
      className={`inline-block max-w-full truncate rounded-full px-2 leading-5 align-middle ${bg ? "" : "border border-current"} ${className}`}
      style={{ color: fg, backgroundColor: bg }}
      title={title}
    >
      {label}
    </span>
  );
};

export default StatusBadge;
